import React, { useEffect, useState } from "react";
import { ArrowDownRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Mobile-only sticky CTA. Appears once the user scrolls past the hero so there
// is always a thumb-friendly "Empezá tu ritual" action on screen (CRO).
export const StickyMobileCTA = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToProducts = () => {
    const el = document.getElementById("productos");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-3 bg-gradient-to-t from-[#120D1A] via-[#120D1A]/95 to-transparent transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={goToProducts}
        className="w-full inline-flex items-center justify-center gap-3 px-6 py-4 text-xs tracking-[0.25em] uppercase font-bold bg-[#FBAD18] hover:bg-[#D8910D] text-[#1A1322] rounded-full shadow-lg shadow-black/40"
      >
        {t.hero.cta_shop}
        <ArrowDownRight size={16} />
      </button>
    </div>
  );
};
